.card
  h4.card__header Umsatzstärkste Produkte
  ul.card__list
    each product in products
      li.card__item
        span.card__item--name #{product.name}
        span.card__item--value #{product.sumLocalized}
